import { Company } from "../../bitrix/types/company";
import { dbCompany } from "../types/company";
import {
  COMPANY_ACCOUNT_NAME_FIELD,
  COMPANY_BUSINESS_FIELD,
  COMPANY_BUSINESS_PARNERUS,
} from "../../bitrix/accountConfig";

export const dbCompanyToBitrixMapper = (
  company: dbCompany,
  accountId: string,
  accountName?: string
): Company => {
  return {
    TITLE: company.TITLE,
    INDUSTRY: company.INDUSTRY,
    UF_CRM_1787074750: company.UF_STATUS,
    UF_CRM_1787074855: company.UF_IRS_STATUS,
    UF_CRM_1787074949: company.UF_STATE_OF_INCORPORATION,
    UF_CRM_1787075056: company.UF_TYPE_OF_SERVICE,
    UF_CRM_1647475173580: company.UF_INCORPORATION_DATE,
    WEB: company.WEB ? [{ VALUE_TYPE: "WORK", VALUE: company.WEB }] : [],
    COMMENTS: company.COMMENTS,
    UF_CRM_PARNERUS_ACCOUNT_ID: accountId,
    [COMPANY_ACCOUNT_NAME_FIELD]: accountName,
    // First Contact (el Mediador) no va aca: un business process lo borra en el
    // alta. Lo escribe setCompanyFirstContact justo despues de crear la empresa.
    // Todo lo que crea la app va marcado como Parnerus: sin esto se mezcla con
    // el resto de la cuenta y le pegan las automatizaciones de los otros negocios.
    [COMPANY_BUSINESS_FIELD]: COMPANY_BUSINESS_PARNERUS,
  };
};
